{
  "form.hint.50_char_left": "characters remaining",
  "form.hint.required": "Required",
  "form.hint.text": "Hint Text",
  "sign_in.button_forgot_password": "Forgot password?",
  "sign_in.form_field_email_label": "Email",
  "sign_in.form_field_email_placeholder": "name@domain.com",
  "sign_in.form_field_password_label": "Password",
  "sign_in.form_field_password_placeholder": "********",
  "sign_in.sign_in": "Sign In",
  "sign_up.fields/title+characters.50_characters_left": "",
  "sign_up.fields/title+characters.50_characters_left.35": "",
  "sign_up.fields/title+characters.fields/hint.hint_text": "wendy@kiipo.com",
  "sign_up.form_field_email_label": "Email",
  "sign_up.form_field_email_placeholder": "name@domain.com",
  "sign_up.form_field_password_hint": "8+ characters. Must include uppercase, lowercase, and a number.",
  "sign_up.form_field_password_label": "Password",
  "sign_up.form_field_password_placeholder": "********",
  "sign_up.sign_up": "Sign Up",
  "sign_up.terms_agreement": "I agree to the <u>Terms and Conditions</u> and <u>Privacy Policy</u>.",
  "dashboard.dashboardTitle": "Dashboard",
  "dashboard.upload_project_config": "Upload",
  "profile.profile": "Profile Settings",
  "profile.profile_heads_up": "Your photo and name will be seen by your collaborators.",
  "profile.my_avatar": "My Avatar",
  "profile.upload_button": "Upload Image",
  "profile.first_name": "First Name",
  "profile.last_name": "Last Name",
  "profile.organization": "Organization / Company / Institute",
  "profile.email": "Email",
  "profile.country": "Country",
  "profile.phone": "Phone Number",
  "profile.password": "Password",
  "profile.mfa": "Multi-Factor Authentication",
  "profile.mfa_info": "Add an extra layer of security to your account by requiring more than just a password to sign in. ",
  "profile.delete_account": "Delete Account",
  "profile.delete_account_info": "Permanently delete your account and all data associated with it.",
  "profile.delete_button": "Delete",
  "profile.change_button": "Change",
  "security_change.confirm_title": "Confirm This Change",
  "security_change.continue_button": "Continue",
  "security_change.cancel_button": "Cancel",
  "security_change.saved_title": "Setting Saved",
  "security_change.saved_message": "Your setting has been saved. You may be asked to sign in again on your other devices.",
  "security_change.error_message": "We couldn't save that change. Please try again.",
  "security_change.done_button": "Done",
  "security_change.close_button": "Close",
  "security_change.email_changed_message": "You may be asked to sign in again on your other devices.",
  "participant.download_data_button": "Download Data",
  "connection.reconnecting_message": "Can't reach Labfront. Your work is safe and we'll keep trying.",
  "connection.retrying_message": "Can't reach Labfront. Retrying...",
  "connection.retry_now_button": "Retry now",
  "connection.sign_in_again_button": "Sign in again",
  "connection.unavailable_message": "Labfront is temporarily unavailable. Please try again.",
  "connection.out_of_date_message": "Connection restored. Some data may be out of date.",
  "connection.reload_button": "Reload",
  "connection.dismiss_button": "Dismiss",
  "connection.checking_session_message": "Checking your session…",
  "rate_limit.wait_message_one": "Too many attempts. Please wait {{count}} second and try again.",
  "rate_limit.wait_message_other": "Too many attempts. Please wait {{count}} seconds and try again.",
  "idle_sign_out.countdown": "Signing out in {{time}}",
  "idle_sign_out.sign_out_button": "Sign out",
  "idle_sign_out.stay_signed_in_button": "Stay signed in",
  "idle_sign_out.warning_message": "You haven't been active in Labfront for a while. For your security, you'll be signed out soon.",
  "idle_sign_out.warning_title": "Are you still there?",
  "questionnaire_draft.already_created_copy_kept": "Your recovery copy is kept, since it may hold changes made after that save. It's offered for review the next time you add a questionnaire.",
  "questionnaire_draft.already_created_message": "An earlier save went through as “{{name}}”, saved {{time}}.",
  "questionnaire_draft.already_created_message_unnamed": "An earlier save of this questionnaire went through.",
  "questionnaire_draft.already_created_title": "This questionnaire is already saved",
  "questionnaire_draft.cancel_button": "Close editor",
  "questionnaire_draft.check_failed_message": "Try again, or go on without it. Going on replaces any copy you have.",
  "questionnaire_draft.check_failed_title": "We couldn't check for a recovery copy",
  "questionnaire_draft.conflict_message": "Your recovery copy is from {{time}}, but the saved questionnaire has changed since. Restoring your copy replaces those changes when you save.",
  "questionnaire_draft.conflict_message_unsent": "You have a recovery copy that hasn't reached Labfront yet, but the saved questionnaire has changed since it was made. Restoring your copy replaces those changes when you save.",
  "questionnaire_draft.conflict_title": "This questionnaire was saved after your recovery copy",
  "questionnaire_draft.create_in_progress_message": "An earlier save of it hasn't finished yet. Try saving again in a moment.",
  "questionnaire_draft.create_in_progress_title": "This questionnaire is still being saved",
  "questionnaire_draft.discard_button": "Discard copy",
  "questionnaire_draft.locked_questions_note": "This project is live, so its questions and display logic stay as they are. Restoring brings back the name, description, color, schedule and reminders.",
  "questionnaire_draft.missing_message": "Your recovery copy is from {{time}}, but the questionnaire it belongs to has been deleted.",
  "questionnaire_draft.missing_message_unsent": "You have a recovery copy that hasn't reached Labfront yet, but the questionnaire it belongs to has been deleted.",
  "questionnaire_draft.missing_title": "This questionnaire no longer exists",
  "questionnaire_draft.offer_message": "You have a recovery copy of this questionnaire from {{time}}, kept while you were editing.",
  "questionnaire_draft.offer_message_unsent": "You have a recovery copy of this questionnaire that hasn't reached Labfront yet.",
  "questionnaire_draft.offer_title": "Restore your unsaved changes?",
  "questionnaire_draft.ok_button": "OK",
  "questionnaire_draft.other_target_message": "It was started from another part of this project. Open it there to restore it.",
  "questionnaire_draft.other_target_title": "Your recovery copy belongs to another questionnaire",
  "questionnaire_draft.restore_anyway_button": "Restore my copy",
  "questionnaire_draft.restore_button": "Restore",
  "questionnaire_draft.retry_button": "Try again",
  "questionnaire_draft.review_confirm": "I've checked, and I want to create a new questionnaire",
  "questionnaire_draft.review_load_failed": "Your last save of this new questionnaire may have gone through, but we couldn't load your saved questionnaires to check. Try again before creating another.",
  "questionnaire_draft.review_message": "Your last save of this new questionnaire may have gone through before your session ended. Check that it isn't already one of these before creating another:",
  "questionnaire_draft.review_title": "Check your saved questionnaires first",
  "questionnaire_draft.start_fresh_button": "Go on without it",
  "questionnaire_draft.status_refused": "Your recovery copy isn't being saved.",
  "questionnaire_draft.status_removal_refused": "Your recovery copy couldn't be removed.",
  "questionnaire_draft.status_removing": "Removing your recovery copy…",
  "questionnaire_draft.status_retry_button": "Try again",
  "questionnaire_draft.status_saved": "Recovery copy saved at {{time}}",
  "questionnaire_draft.status_saving": "Saving a recovery copy…",
  "questionnaire_draft.status_too_large": "This questionnaire is too large to keep a recovery copy.",
  "questionnaire_draft.unsupported_message": "It was saved by a different version of Labfront.",
  "questionnaire_draft.unsupported_title": "Your recovery copy can't be restored",
  "session_cap.countdown": "Signing out in {{time}}",
  "session_cap.warning_message": "For your security, your session ends soon, even while you're working. Save your work now, then sign in again to continue.",
  "sign_in.session_ended_message": "Your session ended. Please sign in again.",
  "sign_in.signed_out_email_change_message": "You were signed out after changing your email.",
  "sign_in.signed_out_inactivity_message": "You were signed out because of inactivity. Please sign in again.",
  "sign_in.signed_out_mfa_change_message": "You were signed out after changing your MFA settings.",
  "security_change.confirm_intro": "Enter your current password so we know it's you.",
  "security_change.confirm_password_label": "Current Password",
  "security_change.confirm_password_placeholder": "Enter your current password",
  "security_change.confirm_mfa_warning": "If your account uses SMS or email for multi-factor authentication, saving may still sign you out everywhere.",
  "security_change.confirm_code_disclosure": "I have an authenticator or recovery code",
  "security_change.confirm_code_label": "Authenticator or Recovery Code",
  "security_change.confirm_code_placeholder": "6-digit or 12-character code",
  "security_change.confirm_code_hint": "Optional. Leave this blank if you don't have one.",
  "security_change.confirm_code_length_error": "Enter the 6-digit authenticator code or the 12-character recovery code.",
  "security_change.confirm_error_generic": "We couldn't confirm it's you. Please check your details and try again."
}
